module.exports = __webpack_public_path__ + "img/tutorial_simulated_03.26108932.gif";